import React from "react";
import { Switch, Typography } from "@mui/material";
import styled from "@emotion/styled";

const AccountHolderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: solid 1px ${({ theme }) => theme.palette.border.secondary};
  padding: ${({ theme }) => theme.spacing(2, 0)};

  &:first-of-type {
    border-top: solid 1px ${({ theme }) => theme.palette.border.secondary};
  }
`;

export interface Props {
  id: number;
  isChecked: boolean;
  firstName: string;
  lastName: string;
  handleChange: (id: number) => void;
}

export const AccountHolderSelector = ({
  id,
  isChecked,
  firstName,
  lastName,
  handleChange,
}: Props) => {
  return (
    <AccountHolderContainer key={`accountHolder-${id}`}>
      <Typography variant="body1">
        {firstName} {lastName}
      </Typography>
      <Switch
        data-testid={`toggle-${id}`}
        checked={isChecked}
        onChange={() => handleChange(id)}
        color="primary"
      />
    </AccountHolderContainer>
  );
};
